import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import AuthServiceV2 from "../../../services/auth.serviceV2";
import "./Styles.css";
import RegulatorService from "../../../services/regulator.service";
import Static_modal from "../etc/Static_modal";

function StatusDroneSec() {
  const { state } = useLocation();
  const [data, setData] = useState("");
  const [datadrone, setDatadrone] = useState("");
  const [frequency, setFrequency] = useState({
    checkbox1: 1,
    checkbox2: 0,
    checkbox3: 0,
    checkbox4: 0,
  });
  const [purpose, setPurpose] = useState({
    checkbox1: 1,
    checkbox2: 0,
    checkbox3: 0,
    checkbox4: 0,
    checkbox5: 0,
    checkbox6: 0,
    checkbox7: 0,
  });
  const [files, setFiles] = useState({
    idcard_file: null,
    homeregis_file: null,
    dronepic_file: null,
    droneserial_file: null,
    remoteserial_file: null,
    selfcert_file: null,
    aircraft_insu_file: null,
    attorney_doc_file: null,
    idcard_attorneyauth_file: null,
    idcard_attorney_file: null,
    legal_result_file: null,
  });
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    console.log(urlParams.get("number"));
    if (
      sessionStorage.getItem("type_user") === "caat" ||
      sessionStorage.getItem("type_user") === "nbtc"
    ) {
      console.log(sessionStorage.getItem("type_user"));
      const check = RegulatorService.GetOneDataDrone(
        parseInt(urlParams.get("number"))
      );
      if (check != null)
        check.then((response) => {
          console.log(response);
          setPurpose(response.data.drone_data.purpose);
          setFrequency(response.data.drone_data.frequency);
          setDatadrone(response.data.drone_data);
          setData(response.data.drone_data.userdata);
          console.log(response.data.drone_data);
          setFiles({
            idcard_file: response.data.drone_data.files.idcard_file,
            homeregis_file: response.data.drone_data.files.homeregis_file,
            dronepic_file: response.data.drone_data.files.dronepic_file,
            droneserial_file: response.data.drone_data.files.droneserial_file,
            remoteserial_file: response.data.drone_data.files.remoteserial_file,
            selfcert_file: response.data.drone_data.files.selfcert_file,
            aircraft_insu_file:
              response.data.drone_data.files.aircraftinsu_file,
            attorney_doc_file: response.data.drone_data.files.attorneydoc_file,
            idcard_attorneyauth_file:
              response.data.drone_data.files.idcardauth_file,
            idcard_attorney_file:
              response.data.drone_data.files.idcardattorney_file,
            legal_result_file: response.data.drone_data.files.legalresult_file,
          });
        });
    } else {
      const check = AuthServiceV2.getonedatadrone(state.drone_id);
      if (check != null)
        check
          .then((response) => {
            console.log(response);
            setPurpose(response.data.drone_data.purpose);
            setFrequency(response.data.drone_data.frequency);
            setDatadrone(response.data.drone_data);

            setData(response.data.drone_data.userdata);
          })
          .catch((error) => {
            setTextBody(error);
            setModalToggle({ ...modalToggle, modalErr: true });
          });
    }
  }, [state]);
  const getfiletoshow = (path) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    console.log(urlParams.get("number"));
    const response = RegulatorService.Getfile(urlParams.get("number"), path);
    response.then((res) => {
      const file = new Blob([res.data], { type: res.data.type });
      const fileUrl = URL.createObjectURL(file);
      //setFileUrl(fileUrl);
      window.open(fileUrl, "_blank");
      // pdfWindow.document.write(
      //   `<iframe src="${fileUrl}" width="100%" height="100%"></iframe>`
      // );
    });
  };
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
  };
  const myStyle = {
    paddingTop: "60px",
  };
  const myStyle1 = {
    paddingTop: "30px",
    color: "#0077B6",
  };
  return (
    <div>
      <div className="container-main" style={{ color: "black" }}>
        <div className="form-section">
          <Form noValidate>
            <Row className="mb-3 row-main" style={{ marginTop: "25px" }}>
              <Form.Label>
                <h2 className="header-main">
                  ขอใบขึ้นทะเบียนเครื่องวิทยุคมนาคม
                </h2>
              </Form.Label>
              <Form.Label>
                <h3 as={Col} className="header-main">
                  ข้อมูลอากาศยานที่ควบคุมการบินจากภายนอก
                </h3>
              </Form.Label>
              <Form.Group as={Col} md="6">
                <Form.Label className="font-cen">Serial Number</Form.Label>
                <Form.Control
                  disabled
                  className="form-input"
                  value={datadrone.drone_serial_number}
                />
              </Form.Group>
              <Form.Group as={Col} md="6">
                <Form.Label className="font-cen">ตราอักษร</Form.Label>
                <Form.Control
                  disabled
                  className="form-input"
                  value={datadrone.drone_brand}
                />
              </Form.Group>
              <Form.Group as={Col} md="6">
                <Form.Label className="font-cen">รุ่น</Form.Label>
                <Form.Control
                  disabled
                  className="form-input"
                  value={datadrone.drone_model}
                />
              </Form.Group>
              <Form.Group as={Col} md="6">
                <Form.Label className="font-cen">
                  อุปกรณ์ที่ติดตั้ง(ถ้ามีโปรดระบุ)/installed accessories
                </Form.Label>
                <Form.Control className="form-input" disabled value={""} />
              </Form.Group>
              <Form.Group as={Col} md="12">
                <Form.Label className="font-cen">น้ำหนัก</Form.Label>
                <div>
                  <Form.Control
                    disabled
                    required
                    id="weight"
                    type="text"
                    placeholder="น้ำหนัก"
                    className="form-input"
                    value={datadrone.weight}
                    pattern="^\d*\.?\d*$"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault(); // Prevents the default "Enter" key behavior
                      }
                    }}
                  />
                </div>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <Form.Label className="font-cen">
                  มี Standard Remote ID
                  <span style={{ color: "red" }}></span>
                </Form.Label>
                <div>
                  <Form.Label className="font-cen">
                    <input
                      disabled
                      name="standardRemoteID"
                      type="checkbox"
                      checked={datadrone.built_in_rid === 1}
                    />
                    &nbsp; "มี Standard Remote ID"
                  </Form.Label>
                </div>
              </Form.Group>
              <div className="card-main" style={{ height: "auto" }}>
                <div style={{ display: "block" }}>
                  <Form.Label className="font-cen">
                    คลื่นความถี่ (MHz) และกำลังส่งออกอากาศสมมูลแบบไอโซทรอปิก
                    <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <Form.Label className="font-censize">
                    <input
                      disabled
                      type="checkbox"
                      name="checkbox1"
                      value="1"
                      checked={frequency[0] === 1}
                    />
                    &nbsp;433.05 – 434.79 MHz กำลังส่งสูงสุด e.i.r.p. 10 mW
                  </Form.Label>
                  <Form.Label className="font-censize">
                    <input
                      disabled
                      type="checkbox"
                      name="checkbox2"
                      value="2"
                      checked={frequency[1] === 1}
                    />
                    &nbsp;2400 – 2500 MHz กำลังส่งสูงสุด e.i.r.p. 100 mW
                  </Form.Label>
                  <Form.Label className="font-censize">
                    <input
                      disabled
                      type="checkbox"
                      name="checkbox3"
                      value="3"
                      checked={frequency[2] === 1}
                    />
                    &nbsp;5725 – 5850 MHz กำลังส่งสูงสุด e.i.r.p. 1000 mW
                  </Form.Label>
                  <Form.Label className="font-censize">
                    <input
                      disabled
                      type="checkbox"
                      name="checkbox4"
                      value="4"
                      checked={frequency[3] === 1}
                    />
                    &nbsp;24.05 – 24.25 GHz กำลังส่งสูงสุด e.i.r.p. 100 mW
                  </Form.Label>
                </div>
              </div>
              <hr />
              <div className="card-main" style={{ height: "auto" }}>
                <div style={{ display: "block" }}>
                  <Form.Label
                    className="font-cen"
                    style={{ marginBottom: "-6.5px" }}
                  >
                    วัตถุประสงค์ของการใช้อากาศยาน aircraft.
                    <span style={{ color: "red" }}>*</span>
                  </Form.Label>
                  <p className="text-description">
                    (สามารถเลือกได้มากกว่า 1 ข้อ)
                  </p>
                  <Form.Label className="font-censize">
                    <input
                      disabled
                      type="checkbox"
                      name="checkbox1"
                      value={parseInt(0)}
                      checked={purpose[0] === 1}
                    />
                    &nbsp; เพื่อการเล่นเป็นงานอดิเรก ความบันเทิง หรือ
                    เพื่อการกีฬา
                  </Form.Label>
                  <Form.Label className="font-censize">
                    <input
                      disabled
                      type="checkbox"
                      name="checkbox2"
                      value={parseInt(0)}
                      checked={purpose[0] === 1}
                    />
                    &nbsp;เพื่อการรายงานเหตุการณ์หรือรายงานจราจร (สื่อมวลชน)
                  </Form.Label>
                  <Form.Label className="font-censize">
                    <input
                      disabled
                      type="checkbox"
                      name="checkbox3"
                      value={parseInt(0)}
                      checked={purpose[2] === 1}
                    />
                    &nbsp;เพื่อการวิจัย ทดลอง ทดสอบ ตามประกาศ กสทช.
                  </Form.Label>
                  <Form.Label className="font-censize">
                    <input
                      disabled
                      type="checkbox"
                      name="checkbox4"
                      value={parseInt(0)}
                      checked={purpose[3] === 1}
                    />
                    &nbsp;เพื่อการวิจัยและพัฒนาอากาศยาน เพื่อการพาณิชย์
                  </Form.Label>
                  <Form.Label className="font-censize">
                    <input
                      disabled
                      type="checkbox"
                      name="checkbox5"
                      value={parseInt(0)}
                      checked={purpose[4] === 1}
                    />
                    &nbsp;เพื่อการถ่ายภาพ
                    ถ่ายทำหรือการแสดงในภาพยนต์หรือรายการโทรทัศน์
                  </Form.Label>
                  <Form.Label className="font-censize">
                    <input
                      disabled
                      type="checkbox"
                      name="checkbox6"
                      value={parseInt(0)}
                      checked={purpose[5] === 1}
                    />
                    &nbsp;เพื่อสำรวจสิ่งปลูกสร้าง
                  </Form.Label>
                </div>
              </div>
            </Row>
            <Row className="mb-3 row-main" style={{ marginTop: "35px" }}>
              <Form.Label>
                {" "}
                <h3
                  as={Col}
                  style={{
                    color: "#0077B6",
                    fontStyle: "normal",
                    fontSize: "39px",
                  }}
                >
                  ข้อมูลอุปกรณ์ควบคุมการบิน
                </h3>
              </Form.Label>
              <Form.Group as={Col} md="6">
                <Form.Label className="font-cen">
                  แบรนด์อุปกรณ์ควบคุมการบิน
                </Form.Label>
                <Form.Control
                  disabled
                  className="form-input"
                  value={datadrone.controller_brand}
                />
              </Form.Group>
              <Form.Group as={Col} md="6">
                <Form.Label className="font-cen">
                  หมายเลขประจำเครื่องอุปกรณ์ควบคุมการบิน
                </Form.Label>
                <Form.Control
                  disabled
                  className="form-input"
                  value={datadrone.controller_serial_number}
                />
              </Form.Group>
            </Row>
            <Row className="mb-3 row-main" style={{ marginTop: "35px" }}>
              <Form.Label>
                <h3
                  as={Col}
                  style={{
                    color: "#0077B6",
                    fontStyle: "normal",
                    fontSize: "39px",
                  }}
                >
                  เอกสารการประกันภัย
                </h3>
              </Form.Label>
              <Form.Group as={Col} md="6">
                <Form.Label className="font-cen">
                  ประเภทกรมธรรม์<span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  disabled
                  required
                  type="text"
                  placeholder=""
                  //disabled
                  className="form-input"
                  value={datadrone.ins_type}
                />
              </Form.Group>
              <Form.Group as={Col} md="6">
                <Form.Label className="font-cen">
                  เลขกรมธรรม์<span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  disabled
                  className="form-input"
                  value={datadrone.ins_number}
                />
              </Form.Group>
              <Form.Group as={Col} md="6">
                <Form.Label className="font-cen">
                  ชื่อบริษัทประกัน<span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  disabled
                  className="form-input"
                  value={datadrone.ins_company_name}
                />
              </Form.Group>
              <Form.Group as={Col} md="6">
                <Form.Label className="font-cen">
                  วงเงินประกัน(ประกันภัยบุคคลที่ 3 วงเงินไม่ต่ำกว่า1ล้านบาท)
                </Form.Label>
                <Form.Control
                  disabled
                  className="form-input"
                  value={datadrone.ins_limit}
                />
                <Form.Control.Feedback type="invalid">
                  กรุณาใส่จำนวนวงเงินตั้งแต่ 1,000,000 บาทค่ะ
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6">
                <Form.Label className="font-cen">
                  ระยะเวลาเริ่มประกัน
                </Form.Label>
                <Form.Control
                  disabled
                  className="form-input"
                  value={datadrone.ins_start}
                />
              </Form.Group>
              <Form.Group as={Col} md="6">
                <Form.Label className="font-cen">
                  ระยะเวลาสิ้นสุดประกัน
                </Form.Label>
                <Form.Control
                  disabled
                  className="form-input"
                  value={datadrone.ins_end}
                />
              </Form.Group>
            </Row>
            <br />
            <Form.Label>
              <h3 as={Col} className="header-main">
                วันที่ครอบครองเครื่องวิทยุคมนาคมที่ใช้ในอากาศยานซึ่งไม่มีนักบิน
              </h3>
            </Form.Label>
            <div className="card-main">
              <div style={{ display: "block" }}>
                <Form.Label className="font-censize">
                  <input
                    disabled
                    type="checkbox"
                    name="option1"
                    checked={datadrone.lic_request === 1}
                  />
                  &nbsp;นำเข้าตามใบอนุญาตนำเข้า
                  <br />
                  Imported according to the Import License
                </Form.Label>
                <Form.Label className="font-censize">
                  <input
                    disabled
                    type="checkbox"
                    checked={datadrone.lic_request === 2}
                  />
                  ซื้อจากร้านค้า
                  <br />
                  Purchased from the distributor/store
                </Form.Label>
                <Form.Label className="font-censize">
                  <input
                    disabled
                    type="checkbox"
                    checked={datadrone.lic_request === 3}
                  />
                  นำเข้ามาใช้งานในประเทศเป็นการชั่วคราว
                  <br />
                  Temporarilty imported in to the country
                </Form.Label>
                <Form.Label className="font-censize">
                  <input
                    disabled
                    type="checkbox"
                    checked={datadrone.lic_request === 4}
                  />
                  รับโอนจากบุคคลอื่น
                  <br />
                  Transfered from the others
                </Form.Label>
                <Form.Label className="font-censize">
                  <input
                    disabled
                    type="checkbox"
                    checked={datadrone.lic_request === 5}
                  />
                  ทำขึ้นตามใบอนุญาต
                  <br />
                  Made according to the Assembly License
                </Form.Label>
              </div>
              {datadrone.lic_request === 1 ? (
                <div
                  style={{
                    position: "relative",
                    marginLeft: "150px",
                  }}
                >
                  <Form.Label className="font-censize">
                    เลขใบอนุญาตนำเข้า<span className="text-red">*</span>
                    <br />
                    Import license number{" "}
                  </Form.Label>
                  <Form.Control
                    disabled
                    value={datadrone.lic_req_data[0]}
                    className="form-input"
                  />
                  <Form.Label className="font-censize">
                    วันที่นำเข้า (วัน/เดือน/ปี พ.ศ.)
                    <span className="text-red">*</span>
                    <br />
                    Import date (d M yyyy)
                  </Form.Label>
                  <Form.Control
                    required
                    value={datadrone.lic_req_data[1]}
                    disabled
                    className="form-input"
                  />
                </div>
              ) : (
                ""
              )}
              {/* {datadrone.lic_request === "2" ? (
                <div
                  style={{
                    position: "relative",
                    marginLeft: "150px",
                  }}
                >
                  <Form.Label className="font-censize">
                    ชื่อร้านค้า<span className="text-red">*</span>
                    <br />
                    Store name{" "}
                  </Form.Label>
                  <Form.Control
                    required
                    id="choos2_1"
                    pattern="[A-Za-z0-9ก-ฮ\u0E00-\u0E7F ._\-\/]*"
                    maxLength={50}
                    type="text"
                    name="file2"
                    disabled={open}
                    value={lic_req_data}
                    onChange={(e) => setLic_req_data(e.target.value)}
                    className="form-input"
                  />
                  <Form.Label className="font-censize">
                    ตามใบเสร็จ/ใบกำกับภาษี ลงวันที่ (วัน/เดือน/ปี พ.ศ.)
                    <span className="text-red">*</span>
                    <br />
                    Bill date (d M yyyy)
                  </Form.Label>
                  <Form.Control
                    required
                    id="choos2_2"
                    type="date"
                    name="file2"
                    //disabled
                    value={lic_req_data1}
                    onChange={(e) => {
                      if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                        setLic_req_data1(e.target.value);
                      }
                    }}
                    className="form-input"
                  />
                </div>
              ) : (
                ""
              )}
              {datadrone.lic_request === "3" ? (
                <div
                  style={{
                    position: "relative",
                    marginLeft: "100px",
                  }}
                >
                  <Form.Label className="font-censize">
                    วันที่เดินทางเข้าประเทศไทย/ Arrival date (mm dd, yyyy){" "}
                  </Form.Label>
                  <Form.Control
                    required
                    id="choos3_1"
                    type="date"
                    name="date"
                    disabled={open}
                    value={lic_req_data}
                    onChange={(e) => {
                      if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                        setLic_req_data(e.target.value);
                      }
                    }}
                    className="form-input"
                  />
                  <Form.Label className="font-censize">
                    จำนวนวันที่พำนักในประเทศไทย (วัน)/
                    <span className="text-red">*</span>
                    <br />
                    Number of days of stay in Thailand (days)
                  </Form.Label>
                  <Form.Control
                    required
                    id="choos3_2"
                    type="text"
                    pattern="[0-9]*"
                    maxLength={50}
                    name="date"
                    disabled={open}
                    value={lic_req_data1}
                    onChange={(e) => setLic_req_data1(e.target.value)}
                    className="form-input"
                  />
                </div>
              ) : (
                ""
              )}
              {datadrone.lic_request === "5" ? (
                <div
                  style={{
                    position: "relative",
                    marginLeft: "100px",
                  }}
                >
                  <Form.Label className="font-censize">
                    เลขที่ใบอนุญาตทำ<span className="text-red">*</span>
                    <br />
                    license number
                  </Form.Label>
                  <Form.Control
                    required
                    id="choos5_1"
                    type="text"
                    name="file2"
                    pattern="[0-9]*"
                    maxLength={50}
                    disabled={open}
                    value={lic_req_data}
                    onChange={(e) => setLic_req_data(e.target.value)}
                    className="form-input"
                  />
                  <Form.Label className="font-censize">
                    วันที่ใบอนุญาตทำ (วัน/เดือน/ปี พ.ศ.)
                    <span className="text-red">*</span>
                    <br />
                    license date(d M yyyy)
                  </Form.Label>
                  <Form.Control
                    required
                    id="choos5_2"
                    type="date"
                    name="date"
                    disabled={open}
                    value={lic_req_data1}
                    onChange={(e) => {
                      if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                        setLic_req_data1(e.target.value);
                      }
                    }}
                    className="form-input"
                  />
                  <Form.Label className="font-censize">
                    วันที่ทำเครื่องวิทยุคมนาคม (วัน/เดือน/ปี พ.ศ.)
                    <span className="text-red">*</span>
                    <br />
                    made date radio communication device (d M yyyy)
                  </Form.Label>
                  <Form.Control
                    required
                    className="form-input"
                    id="choos5_3"
                    type="date"
                    name="date"
                    disabled={open}
                    value={lic_req_data2}
                    onChange={(e) => {
                      if (/^\d{4}-\d{2}-\d{2}$/.test(e.target.value)) {
                        setLic_req_data2(e.target.value);
                      }
                    }}
                  />
                </div>
              ) : (
                ""
              )} */}
            </div>
            <Row className="mb-3 row-main" style={{ marginTop: "25px" }}>
              <h3 as={Col} className="header-main">
                ข้อมูลผู้ขอขึ้นทะเบียน
              </h3>
              <Form.Group as={Col} md="4">
                <Form.Label className="font-cen">คำนำหน้าชื่อ</Form.Label>

                <Form.Control
                  disabled
                  value={data.title}
                  className="form-input"
                ></Form.Control>
              </Form.Group>

              <Form.Group as={Col} md="4">
                <Form.Label className="font-cen">ชื่อ</Form.Label>
                <Form.Control
                  required
                  disabled
                  type="text"
                  value={data.f_name}
                  className="form-input"
                />
              </Form.Group>
              <Form.Group as={Col} md="4">
                <Form.Label className="font-cen">นามสกุล</Form.Label>
                <Form.Control
                  disabled
                  type="text"
                  value={data.l_name}
                  className="form-input"
                />
              </Form.Group>
              <Form.Group as={Col} md="12">
                <Form.Label className="font-cen">เลขบัตรประชาชน</Form.Label>
                <Form.Control
                  disabled
                  type="number"
                  //value="1-2345-12345-12-3"
                  value={data.idnum}
                  className="form-input"
                />
              </Form.Group>
              <Form.Group as={Col} md="4">
                <Form.Label className="font-cen">อีเมล</Form.Label>
                <Form.Control
                  disabled
                  type="email"
                  //value="name@example.com"
                  value={data.email}
                  className="form-input"
                />
              </Form.Group>
              <Form.Group as={Col} md="4">
                <Form.Label className="font-cen">เบอร์โทรศัพท์</Form.Label>
                <Form.Control
                  disabled
                  type="number"
                  aria-label="Amount (to the nearest dollar)"
                  value={data.phone}
                  className="form-input"
                />
              </Form.Group>
              <Form.Group as={Col} md="4">
                <Form.Label className="font-cen">อาชีพ</Form.Label>
                <Form.Control
                  disabled
                  type="text"
                  value={data.occupation}
                  className="form-input"
                />
              </Form.Group>
              <Form.Group as={Col} md="3">
                <Form.Label className="font-cen">วัน-เดือน-ปี เกิด</Form.Label>
                <Form.Control
                  disabled
                  //type="date"
                  value={data.date_of_birth}
                  className="form-input"
                />
              </Form.Group>
              <Form.Group as={Col} md="3">
                <Form.Label className="font-cen">อายุ</Form.Label>
                <Form.Control
                  disabled
                  type="number"
                  value={data.age}
                  className="form-input"
                />
              </Form.Group>
              <Form.Group as={Col} md="3">
                <Form.Label className="font-cen">เชื้อชาติ</Form.Label>
                <Form.Control
                  disabled
                  type="text"
                  value={data.nationality}
                  className="form-input"
                />
              </Form.Group>
              <Form.Group as={Col} md="3">
                <Form.Label className="font-cen">สัญชาติ</Form.Label>
                <Form.Control
                  disabled
                  type="text"
                  value={data.nationality}
                  className="form-input"
                />
              </Form.Group>
            </Row>
            <Row className="mb-3 row-main" style={{ marginTop: "25" }}>
              <Form.Label>
                <h3 as={Col} className="header-main">
                  ที่อยู่ตามบัตรประชาชนหรือทะเบียนบ้าน
                </h3>
              </Form.Label>
              <Form.Group as={Col} md="8">
                <Form.Label className="font-cen">
                  ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)
                </Form.Label>
                <Form.Control
                  disabled
                  type="text"
                  value={data.address}
                  className="form-input"
                />
              </Form.Group>
              <Form.Group as={Col} md="4">
                <Form.Label className="font-cen">จังหวัด</Form.Label>
                <Form.Control
                  disabled
                  type="text"
                  value={data.province}
                  className="form-input"
                />
              </Form.Group>
              <Form.Group as={Col} md="4">
                <Form.Label className="font-cen">ตำบล</Form.Label>
                <Form.Control
                  disabled
                  type="text"
                  value={data.sub_dis}
                  className="form-input"
                />
              </Form.Group>
              <Form.Group as={Col} md="4">
                <Form.Label className="font-cen">อำเภอ</Form.Label>
                <Form.Control
                  disabled
                  type="text"
                  value={data.dis}
                  className="form-input"
                />
              </Form.Group>
              <Form.Group as={Col} md="4">
                <Form.Label className="font-cen">รหัสไปรษณีย์</Form.Label>
                <Form.Control
                  disabled
                  type="number"
                  value={data.pos_code}
                  className="form-input"
                />
              </Form.Group>
            </Row>
            <Row className="mb-3 row-main" style={{ marginTop: "25px" }}>
              <Form.Label>
                <h3 as={Col} className="header-main">
                  ที่อยู่ปัจจุบัน
                </h3>
              </Form.Label>
              <Form.Group as={Col} md="8">
                <Form.Label className="font-cen">
                  ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)
                </Form.Label>
                <Form.Control
                  disabled
                  type="text"
                  value={data.cur_address}
                  className="form-input"
                />
              </Form.Group>

              <Form.Group as={Col} md="4">
                <Form.Label className="font-cen">จังหวัด</Form.Label>
                <Form.Control
                  disabled
                  type="text"
                  value={data.cur_province}
                  className="form-input"
                />
              </Form.Group>
              <Form.Group as={Col} md="4">
                <Form.Label className="font-cen">ตำบล</Form.Label>
                <Form.Control
                  disabled
                  type="text"
                  value={data.cur_sub_dis}
                  className="form-input"
                />
              </Form.Group>
              <Form.Group as={Col} md="4">
                <Form.Label className="font-cen">อำเภอ</Form.Label>
                <Form.Control
                  disabled
                  type="text"
                  value={data.cur_dis}
                  className="form-input"
                />
              </Form.Group>
              <Form.Group as={Col} md="4">
                <Form.Label className="font-cen">รหัสไปรษณีย์</Form.Label>
                <Form.Control
                  disabled
                  type="number"
                  value={data.cur_poscode}
                  className="form-input"
                />
              </Form.Group>
            </Row>
            <Row className="mb-3 row-main">
              <Form.Label>
                <h3 as={Col} className="header-main">
                  เอกสารที่นำส่ง
                </h3>
              </Form.Label>

              <Form.Group as={Col} md="12">
                <Form.Label className="font-cen" style={{ fontSize: "30px" }}>
                  เอกสารแสดงตน
                </Form.Label>
                <Form.Label className="font-cen">
                  สำเนาบัตรประจำตัวประชาชน
                  <span style={{ color: "red" }}>***</span>
                </Form.Label>

                <Row className="mb-3">
                  <Col md={2} style={{ display: "block" }}>
                    <Form.Control
                      id="idcard_file"
                      name="idcard_file"
                      type="file"
                      disabled
                      className="form-importf"
                    />
                  </Col>

                  <Col>
                    <div
                      onClick={() => {
                        if (files.idcard_file.name === null) {
                        } else {
                          getfiletoshow(files.idcard_file.path);
                        }
                      }}
                    >
                      <Form.Control
                        style={{ cursor: "pointer" }}
                        //disabled={open}
                        required
                        md={7}
                        className="form-import-val"
                        type="text"
                        placeholder="No file Chosen....."
                        value={
                          files.idcard_file === null
                            ? "No file Chosen....."
                            : files.idcard_file.name
                        }
                        readOnly
                      />
                    </div>
                  </Col>
                </Row>
              </Form.Group>

              <Form.Group as={Col} md="12">
                <Form.Label className="font-cen">
                  สำเนาทะเบียนบ้าน
                  <span style={{ color: "red" }}>***</span>
                </Form.Label>
                <Row className="mb-3">
                  <Col md={2} style={{ display: "block" }}>
                    <Form.Control
                      id="homeregis_file"
                      type="file"
                      name="homeregis_file"
                      disabled
                      className="form-importf"
                    />
                  </Col>
                  <Col md={10}>
                    <div
                      onClick={() => {
                        if (files.homeregis_file.name === null) {
                        } else {
                          getfiletoshow(files.homeregis_file.path);
                        }
                      }}
                    >
                      <Form.Control
                        style={{ cursor: "pointer" }}
                        //disabled={open}
                        required
                        className="form-import-val"
                        type="text"
                        placeholder="No file Chosen....."
                        value={
                          files.homeregis_file === null
                            ? "No file Chosen....."
                            : files.homeregis_file.name
                        }
                        readOnly
                      />
                    </div>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group as={Col} md="12">
                <Form.Label className="font-cen" style={{ fontSize: "30px" }}>
                  เอกสารแสดงลักษณะทางเทคนิค
                </Form.Label>
                <Form.Label className="font-cen">
                  รูปถ่ายของ Drone / UAV’s picture
                  <span style={{ color: "red" }}>***</span>
                </Form.Label>
                <Row className="mb-3">
                  <Col md={2} style={{ display: "block" }}>
                    <Form.Control
                      id="dronepic_file"
                      type="file"
                      name="dronepic_file"
                      disabled
                      className="form-importf"
                    />
                  </Col>
                  <Col md={10}>
                    <div
                      onClick={() => {
                        if (files.dronepic_file.name === null) {
                        } else {
                          getfiletoshow(files.dronepic_file.path);
                        }
                      }}
                    >
                      <Form.Control
                        style={{ cursor: "pointer" }}
                        //disabled={open}
                        required
                        className="form-import-val"
                        type="text"
                        placeholder="No file Chosen....."
                        value={
                          files.dronepic_file === null
                            ? "No file Chosen....."
                            : files.dronepic_file.name
                        }
                        readOnly
                      />
                    </div>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group as={Col} md="12">
                <Form.Label className="font-cen">
                  รูปถ่ายหมายเลขประจำเครื่อง Drone ที่เห็น QR CODE/Bar Code
                  ที่ชัดเจน <span style={{ color: "red" }}>***</span>
                  <br />A photograph of the drone's serial number with a clear
                  QR Code / Bar Code.
                </Form.Label>
                <Row className="mb-3">
                  <Col md={2} style={{ display: "block" }}>
                    <Form.Control
                      id="droneserial_file"
                      type="file"
                      name="droneserial_file"
                      disabled
                      className="form-importf"
                    />
                  </Col>
                  <Col md={10}>
                    <div
                      onClick={() => {
                        if (files.droneserial_file.name === null) {
                        } else {
                          getfiletoshow(files.droneserial_file.path);
                        }
                      }}
                    >
                      <Form.Control
                        style={{ cursor: "pointer" }}
                        //disabled={open}
                        required
                        className="form-import-val"
                        type="text"
                        placeholder="No file Chosen....."
                        value={
                          files.droneserial_file === null
                            ? "No file Chosen....."
                            : files.droneserial_file.name
                        }
                        readOnly
                      />
                    </div>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group as={Col} md="12">
                <Form.Label className="font-cen">
                  รูปถ่ายหมายเลขประจำเครื่องอุปกรณ์ควบคุมการบิน Drone ที่เห็น QR
                  CODE/Bar Code ที่ชัดเจน
                  <span style={{ color: "red" }}>***</span>
                  <br />A photograph of the remote controller's serial number
                  with a clear QR Code / Bar Code
                </Form.Label>
                <Row className="mb-3">
                  <Col md={2} style={{ display: "block" }}>
                    <Form.Control
                      id="remoteserial_file"
                      type="file"
                      name="remoteserial_file"
                      disabled
                      className="form-importf"
                    />
                  </Col>
                  <Col md={10}>
                    <div
                      onClick={() => {
                        if (files.remoteserial_file.name === null) {
                        } else {
                          getfiletoshow(files.remoteserial_file.path);
                        }
                      }}
                    >
                      <Form.Control
                        style={{ cursor: "pointer" }}
                        //disabled={open}
                        required
                        className="form-import-val"
                        type="text"
                        placeholder="No file Chosen....."
                        value={
                          files.remoteserial_file === null
                            ? "No file Chosen....."
                            : files.remoteserial_file.name
                        }
                        readOnly
                      />
                    </div>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group as={Col} md="12">
                <Form.Label className="font-cen">
                  หนังสือรับรองตนเอง
                  <span style={{ color: "red" }}>***</span>
                </Form.Label>
                <Row className="mb-3">
                  <Col md={2} style={{ display: "block" }}>
                    <Form.Control
                      id="selfcert_file"
                      type="file"
                      name="selfcert_file"
                      disabled
                      className="form-importf"
                    />
                  </Col>
                  <Col md={10}>
                    <div
                      onClick={() => {
                        if (files.selfcert_file.name === null) {
                        } else {
                          getfiletoshow(files.selfcert_file.path);
                        }
                      }}
                    >
                      <Form.Control
                        style={{ cursor: "pointer" }}
                        //disabled={open}
                        required
                        className="form-import-val"
                        type="text"
                        placeholder="No file Chosen....."
                        value={
                          files.selfcert_file === null
                            ? "No file Chosen....."
                            : files.selfcert_file.name
                        }
                        readOnly
                      />
                    </div>
                  </Col>
                </Row>
              </Form.Group>

              <Form.Group as={Col} md="12">
                <Form.Label className="font-cen">
                  สำเนาเอกสารประกันภัยอากาศยาน
                  <span style={{ color: "red" }}>***</span>
                </Form.Label>
                <Row className="mb-3">
                  <Col md={2} style={{ display: "block" }}>
                    <Form.Control
                      id="aircraft_insu_file"
                      type="file"
                      name="aircraft_insu_file"
                      disabled
                      className="form-importf"
                    />
                  </Col>
                  <Col md={10}>
                    <div
                      onClick={() => {
                        if (files.aircraft_insu_file.name === null) {
                        } else {
                          getfiletoshow(files.aircraft_insu_file.path);
                        }
                      }}
                    >
                      <Form.Control
                        style={{ cursor: "pointer" }}
                        //disabled={open}
                        required
                        className="form-import-val"
                        type="text"
                        placeholder="No file Chosen....."
                        value={
                          files.aircraft_insu_file === null
                            ? "No file Chosen....."
                            : files.aircraft_insu_file.name
                        }
                        readOnly
                      />
                    </div>
                  </Col>
                </Row>
              </Form.Group>

              <Form.Group as={Col} md="12">
                <Form.Label className="font-cen" style={{ fontSize: "30px" }}>
                  เอกสารหลักฐานเพิ่มเติมกรณีมอบอำนาจ
                </Form.Label>
                <Form.Label className="font-cen">
                  หนังสือมอบอำนาจ / Power of Attorney document
                </Form.Label>
                <Row className="mb-3">
                  <Col md={2} style={{ display: "block" }}>
                    <Form.Control
                      //required
                      id="attorney_doc_file"
                      type="file"
                      name="attorney_doc_file"
                      disabled
                      className="form-importf"
                    />
                  </Col>
                  <Col md={10}>
                    <div
                      onClick={() => {
                        if (files.attorney_doc_file.name === null) {
                        } else {
                          getfiletoshow(files.attorney_doc_file.path);
                        }
                      }}
                    >
                      <Form.Control
                        style={{ cursor: "pointer" }}
                        className="form-import-val"
                        //disabled={open}
                        type="text"
                        placeholder="No file Chosen....."
                        value={
                          files.attorney_doc_file === null
                            ? "No file Chosen....."
                            : files.attorney_doc_file.name
                        }
                        readOnly
                      />
                    </div>
                  </Col>
                </Row>
              </Form.Group>

              <Form.Group as={Col} md="12">
                <Form.Label className="font-cen">
                  สำเนาบัตรประจำตัวประชาชนผู้มอบอำนาจ / Copy of ID card of the
                  authorized person.
                </Form.Label>
                <Row className="mb-3">
                  <Col md={2} style={{ display: "block" }}>
                    <Form.Control
                      //required
                      id="idcard_attorneyauth_file"
                      type="file"
                      name="idcard_attorneyauth_file"
                      disabled
                      className="form-importf"
                    />
                  </Col>
                  <Col md={10}>
                    <div
                      onClick={() => {
                        if (files.idcard_attorneyauth_file.name === null) {
                        } else {
                          getfiletoshow(files.idcard_attorneyauth_file.path);
                        }
                      }}
                    >
                      <Form.Control
                        style={{ cursor: "pointer" }}
                        className="form-import-val"
                        //disabled={open}
                        type="text"
                        placeholder="No file Chosen....."
                        value={
                          files.idcard_attorneyauth_file === null
                            ? "No file Chosen....."
                            : files.idcard_attorneyauth_file.name
                        }
                        readOnly
                      />
                    </div>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group as={Col} md="12">
                <Form.Label className="font-cen">
                  สำเนาบัตรประจำตัวประชาชนผู้รับมอบอำนาจ / Copy of ID card of
                  the Attorney.
                </Form.Label>
                <Row className="mb-3">
                  <Col md={2} style={{ display: "block" }}>
                    <Form.Control
                      //required
                      id="idcard_attorney_file"
                      type="file"
                      name="idcard_attorney_file"
                      disabled
                      className="form-importf"
                    />
                  </Col>
                  <Col md={10}>
                    <div
                      onClick={() => {
                        if (files.idcard_attorney_file.name === null) {
                        } else {
                          getfiletoshow(files.idcard_attorney_file.path);
                        }
                      }}
                    >
                      <Form.Control
                        style={{ cursor: "pointer" }}
                        className="form-import-val"
                        //disabled={open}
                        type="text"
                        placeholder="No file Chosen....."
                        value={
                          files.idcard_attorney_file === null
                            ? "No file Chosen....."
                            : files.idcard_attorney_file.name
                        }
                        readOnly
                      />
                    </div>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group as={Col} md="12">
                <Form.Label className="font-cen" style={{ fontSize: "30px" }}>
                  เอกสารดำเนินคดี
                </Form.Label>
                <Form.Label className="font-cen">
                  ผลการดำเนินคดี / Legal result
                </Form.Label>
                <Row className="mb-3">
                  <Col md={2} style={{ display: "block" }}>
                    <Form.Control
                      //required
                      id="legal_result_file"
                      type="file"
                      name="legal_result_file"
                      disabled
                      className="form-importf"
                    />
                  </Col>
                  <Col md={10}>
                    <div
                      onClick={() => {
                        if (files.legal_result_file.name === null) {
                        } else {
                          getfiletoshow(files.legal_result_file.path);
                        }
                      }}
                    >
                      <Form.Control
                        style={{ cursor: "pointer" }}
                        className="form-import-val"
                        //disabled={open}
                        type="text"
                        placeholder="No file Chosen....."
                        value={
                          files.legal_result_file === null
                            ? "No file Chosen....."
                            : files.legal_result_file.name
                        }
                        readOnly
                      />
                    </div>
                  </Col>
                </Row>
              </Form.Group>
            </Row>

            <Static_modal
              modalwaiting={modalToggle.modalwait}
              modalErr={modalToggle.modalErr}
              modalSuccess={modalToggle.modalSuccess}
              modalDenied={modalToggle.modalDenied}
              textBody={textBody}
              getHandle={handleClose_Modal}
            />
          </Form>
        </div>
      </div>
    </div>
  );
}
export default StatusDroneSec;
